import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { StoreCreateionAllRegions } from "features/admin/core/domain/admin-store-creation-new-region.model";
import {
  AdminGetStoreCreationNewRegionRepository,
  AdminGetStoreCreationNewRegionResponse,
} from "features/admin/data/repository/admin.repository";
import { RootState } from "features/config/store";

export enum AdminGetStoreCreationNewRegionState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: AdminGetStoreCreationNewRegionState;
  message: string;
  data: Array<StoreCreateionAllRegions> | undefined;
}

const initialState: InitialState = {
  status: AdminGetStoreCreationNewRegionState.initial,
  message: "",
  data: undefined,
};

export const adminGetStoreCreationNewRegion = createAsyncThunk(
  "adminGetStoreCreationNewRegion",
  async (_, { rejectWithValue }) => {
    try {
      const response: AdminGetStoreCreationNewRegionResponse =
        await AdminGetStoreCreationNewRegionRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }

        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const adminGetStoreCreationNewRegionSlice = createSlice({
  name: "adminGetStoreCreationNewRegion",
  initialState,
  reducers: {
    resetAdminGetStoreCreationNewRegionSliceStatus: (state) => {
      state.status = AdminGetStoreCreationNewRegionState.initial;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminGetStoreCreationNewRegion.pending, (state) => {
        state.status = AdminGetStoreCreationNewRegionState.inProgress;
      })
      .addCase(adminGetStoreCreationNewRegion.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = AdminGetStoreCreationNewRegionState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(adminGetStoreCreationNewRegion.rejected, (state, action) => {
        state.status = AdminGetStoreCreationNewRegionState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectAdminGetStoreCreationNewRegion = (state: RootState) =>
  state.adminGetStoreCreationNewRegion;

export const { resetAdminGetStoreCreationNewRegionSliceStatus } =
  adminGetStoreCreationNewRegionSlice.actions;

export default adminGetStoreCreationNewRegionSlice.reducer;
